import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router-dom/Link';
import { connect } from 'react-redux';
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import chunk from 'lodash/chunk';
import extend from 'lodash/extend';
import withRouter from 'react-router/withRouter';
import Slider from 'react-slick';
import Ad from '../../../../components/ad/ad';
import Social from '../../../../components/social/social';
import NotFound from '../../../../components/not_found_component/not_found_component';
import FranchiseIntro from '../../../../components/franchise_intro/franchise_intro';
import Slug from '../../../../components/slug/slug';
import FCLink from '../../../../components/fc_link/fc_link';
import legacyImageAssetUtil from '../../../../../utils/legacy_image_asset_util';
import scrollToEl from '../../../../../utils/scroll_to_el_util';
import loadDataYear from './mic_year_page_state_manager';
import loadDataSector from './mic_sector_page_state_manager';
import log from '../../../../../services/logger_service';
import { canUseDOM } from 'exenv';

function Company(company, sector = false, config) {
  return (
    <div
      className={`mic-year-page__slide-company${
        sector ? ' mic-year-page__slide-company--sector' : ''
      }`}
      key={`company-${company.name}`}
    >
      <FCLink config={config} to={`/company/${company.url}`}>
        <div className="mic-year-page__slide-company-content">
          <span className="mic-year-page__slide-company-rank">
            {Number(company.ranking) < 10 ? '0' : ''}
            {company.ranking}
          </span>
          <span className="mic-year-page__slide-company-name">
            {company.name}
          </span>
          {company.why || company.for ? (
            <h3 className="mic-year-page__slide-company-reason">
              {company.why || company.for}
            </h3>
          ) : null}
        </div>
      </FCLink>
    </div>
  );
}

function CompanySection(companies, config) {
  return (
    <section
      className="mic-year-page__slide"
      key={`mic-section-${get(companies, '[0].name')}`}
    >
      {companies.map(cpy => Company(cpy, false, config))}
      <div className="mic-year-page__slide-currently-showing">
        {get(companies, '[0].ranking') < 10 ? '0' : ''}
        {`${get(companies, '[0].ranking')} - ${get(companies, '[9].ranking')}`}
      </div>
    </section>
  );
}

function SectorSection(
  sector,
  micYear,
  year,
  sectorName,
  index,
  numSectors,
  ads,
  config
) {
  const sectorUrl = get(sector, 'url');
  return (
    <section
      className={`franchise-accordion-section franchise-accordion-section--mic-year franchise-accordion-section--${sectorUrl}`}
      key={`section-${get(sector, 'name')}`}
    >
      {sectorUrl === sectorName ? (
        <Social
          empty={false}
          enableSticky={false}
          modifier="mic-year-sector"
          uri={`https://www.fastcompany.com/most-innovative-companies/${year}/sectors/${sectorUrl}`}
          text={encodeURIComponent(
            `@FastCompany's Most Innovative Companies ${year} in ${get(
              sector,
              'name'
            )} #FCMostInnovative`
          )}
        />
      ) : (
        ''
      )}
      <Link
        className="franchise-accordion-section__title-row franchise-accordion-section--mic-year__title-row"
        to={
          sectorUrl === sectorName
            ? `/most-innovative-companies/${year}`
            : `/most-innovative-companies/${year}/sectors/${sectorUrl}`
        }
      >
        <h2 className="franchise-accordion-section__title franchise-accordion-section--mic-year__title">
          {sector.name}
        </h2>
        <img
          className={`franchise-accordion-section__title-icon franchise-accordion-section--mic-year__title-icon${
            sectorUrl === sectorName
              ? ' franchise-accordion-section__title-icon--active'
              : ''
          }`}
          src="//images.fastcompany.net/image/upload/q_auto,fl_lossy/v1495723987/arrow-list-down-fix.svg"
          alt="arrow icon"
          title="arrow icon"
        />
      </Link>
      <div
        className={`franchise-accordion-section__list franchise-accordion-section--mic-year__list${
          sectorUrl === sectorName
            ? ' franchise-accordion-section--mic-year__list--active'
            : ''
        }`}
      >
        {sector.list.map(cpy => Company(cpy, true, config))}
      </div>

      {index === Math.floor(numSectors / 3) ||
      index === Math.floor(numSectors / 3) * 2 ? (
        <div className="franchise-accordion-section__ff-ad-container franchise-accordion-section--mic-year__ff-ad-container">
          <Ad {...ads} pos="btf" name="flexiblebillboard_1" noLazyLoad={true} />
          <Ad {...ads} pos="btf" name="mobileparallax_1" noLazyLoad={true} />
        </div>
      ) : (
        ''
      )}
    </section>
  );
}

// eslint-disable-next-line react/prefer-stateless-function
class MicYear extends Component {
  static loadData(store) {
    const navHist = get(store.getState(), 'config.navHistory');
    const sector =
      get(navHist, `[${navHist.length - 1}]`, '').indexOf('sectors') > -1;
    if (sector) {
      return loadDataSector(store);
    }
    return loadDataYear(store);
  }

  constructor(props) {
    super(props);

    const prevArrow = <button type="button">PREV</button>;

    const nextArrow = <button type="button">NEXT</button>;

    this.state = {
      sector: get(this, 'props.match.params.sector'),
      settings: {
        prevArrow,
        nextArrow,
        className: 'mic-year-page__slider',
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        slide: '.mic-section-slide'
      }
    };
  }

  componentDidMount() {
    const adData = get(this.props.micYearPage, 'ads');

    if (canUseDOM) {
      if (adData !== undefined) {
        // Update the data layer
        extend(window.digitalData.page.pageInfo, {
          adPath: `/4160/mv.fc/${adData.model.adzone}`
        });
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      sector: get(nextProps, 'match.params.sector')
    });
  }

  componentDidUpdate() {
    scrollToEl(
      `.franchise-accordion-section--${get(this, 'props.match.params.sector')}`,
      150
    );
  }

  render() {
    if (this.props.micYearPage.error || this.props.status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.micYearPage.isLoading === false) {
      const adData = get(this.props, 'micYearPage.ads');
      const combinedAdModel = extend(
        {},
        { baseConfig: get(adData, 'config.baseConfig') },
        { definitions: get(adData, 'config.definitions') },
        { model: get(adData, 'model') }
      );

      const year = this.props.year || get(this, 'props.match.params.year');

      const encodedText = encodeURIComponent(
        `@FastCompany's Most Innovative Companies ${year} #FCMostInnovative`
      );
      const uri = `https://www.fastcompany.com/most-innovative-companies/${year}`;

      const { settings } = this.state;
      let micSector = get(this.props, 'micSector', []);

      if (!Array.isArray(micSector)) {
        log.error(
          `micSector is not an array, url: ${get(
            this.props,
            'config.navHistory[0]'
          )}`
        );
        micSector = [];
      }
      return (
        <section className="mic-year-page">
          <Ad {...combinedAdModel} name="oop" slug={false} oop={true} />

          <div className="ad-container ad-container--gray ad-container--hide-for-small">
            <Ad
              {...combinedAdModel}
              name="flexiblebillboard_1"
              noLazyLoad={true}
            />
          </div>

          <div className="ad-container ad-container--hide-for-medium-up post__article-top-ad-wrapper">
            <Ad
              {...combinedAdModel}
              name="mobileleaderboard_short"
              noLazyLoad={true}
            />
          </div>

          <FranchiseIntro
            poster={legacyImageAssetUtil(
              this.props.micYearDescription.logo_url
            )}
            title={`Most Innovative Companies ${year}`}
            desc={this.props.micYearDescription.intro}
            social={{
              enableSticky: false,
              modifier: 'feature-feed',
              text: encodedText,
              uri
            }}
            topValue={0}
          />

          <Slug className="mic-year-page" slugName="Honorees by Rank" />

          <div className="mic-year-page__slider-row">
            <Slider {...settings}>
              {this.props.micYear.map(companies =>
                CompanySection(companies, this.props.config)
              )}
            </Slider>
          </div>

          <Slug className="mic-year-page" slugName="Honorees by Sector" />

          {micSector.map((sector, index) =>
            SectorSection(
              sector,
              this.props.micYear,
              year,
              this.state.sector,
              index,
              get(Object.keys(this.props.micSector), 'length'),
              combinedAdModel,
              this.props.config
            )
          )}

          <div className="ad-container">
            <Ad
              {...combinedAdModel}
              name="flexiblebillboard_2"
              noLazyLoad={true}
            />
            <Ad
              {...combinedAdModel}
              name="mobilerectangle_1"
              noLazyLoad={true}
            />
          </div>
        </section>
      );
    }
    return null;
  }
}

function mapStateToProps(state = {}) {
  const micData = chunk(get(state, 'micYear.data.rows'), 10);
  const micYearDesc = get(state, 'micYearDescription.data.rows[0]');
  return {
    config: state.config || {},
    status: state.status.code,
    micYearPage: Object.keys(get(state, 'micYearPage')).length
      ? state.micYearPage
      : get(state, 'micSectorPage') || { error: true },
    micYear: micData || { error: true },
    year: get(state, 'micYear.year'),
    micSector: get(state, 'micSector.data.rows') || { error: true },
    micYearDescription: micYearDesc || { error: true }
  };
}

MicYear.propTypes = {
  config: PropTypes.shape({}).isRequired,
  status: PropTypes.number,
  micYearPage: PropTypes.shape({
    ads: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  year: PropTypes.string,
  micYear: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({}))).isRequired,
  micYearDescription: PropTypes.shape({
    logo_url: PropTypes.string,
    intro: PropTypes.string
  }),
  micSector: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

MicYear.defaultProps = {
  status: 200,
  micYearPage: PropTypes.shape({
    isLoading: false,
    error: false,
    errorMessage: 'Error in micYearPage Props'
  }),
  year: '',
  micYearDescription: PropTypes.shape({
    logo_url: '',
    intro: ''
  })
};

export default withRouter(connect(mapStateToProps)(MicYear));
